import React from 'react'

import DeliveryLayout from '../../components/universal/delivery-layout'
import DeliveryContent from '../../components/public/delivery'

const LoginPage = () => {
    return(
        <DeliveryLayout Content={() => <DeliveryContent/>}/>
    )
}

export default LoginPage